export default __webpack_public_path__ + "static/167-5ac43f583aec8fee7f51ff0cc072ec03.jpg";